import type { PreloadedEntryPoint } from 'react-relay';
import { QueryPromisesMap } from '@atlassian/relay-query-promises';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type { AnyEntryPoint } from '@jira/platform__entry-point/src/common/types.tsx';

export const waitForEntryPoint = <TEntryPoint extends AnyEntryPoint>(
	entryPointConfig: PreloadedEntryPoint<TEntryPoint>,
): Promise<PromiseSettledResult<unknown>[]> => {
	const promises: Promise<unknown>[] = [];

	try {
		entryPointConfig.getComponent();
	} catch (err) {
		if (err instanceof Promise) {
			promises.push(err);
		} else {
			throw err;
		}
	}
	const { queries, entryPoints } = entryPointConfig;
	if (queries) {
		Object.keys(queries).forEach((key) => {
			if (queries[key].id) {
				const queryPromise = QueryPromisesMap.get(String(queries[key].id));

				if (queryPromise) {
					promises.push(queryPromise);
				}
			}
		});
	}

	if (entryPoints) {
		Object.keys(entryPoints).forEach((key) => {
			const nestedEntryPointPromise = waitForEntryPoint(entryPoints[key]);
			promises.push(nestedEntryPointPromise);
		});
	}

	return Promise.allSettled(promises);
};
